import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { IncidentModel, IncidentNoteModel } from '@models';

import { IncidentNotesComponent } from '../incident-notes';

@Component({
  imports: [MatDialogModule, IncidentNotesComponent],
  selector: 'avs-notes-dialog',
  templateUrl: './notes-dialog.component.html',
})
export class NotesDialogComponent {
  protected data = inject<{ incident: IncidentModel }>(MAT_DIALOG_DATA);
  protected notes = signal<IncidentNoteModel[]>([]);
}
